// extracted by mini-css-extract-plugin
export default {"items-section":"ItemList_items-section__OhTkN","items-container":"ItemList_items-container__s-dTt","loading":"ItemList_loading__bTBQ5","went_wrong":"ItemList_went_wrong__UPTVn"};